/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * Copy mode when copying objects from/to a Module.
 * @author  PASCALLacombe
 */
export default class CopyMode extends Enum{

	/**
	 * The enum value.
	 */
	value = null;

	/**
	 * Only copies the selected objects.
	 */
	static  SELECTION_ONLY = CopyMode.newLiteral("selectionOnly");

	/**
	 * Copies the selected objects, as well as any common relationships that might be between them
	 */
	static  COMMON_RELATIONSHIPS = CopyMode.newLiteral("commonRelationships");

	/**
	 * Copies the selected object, as well as any relationships to them
	 */
	static  ALL_RELATIONSHIPS = CopyMode.newLiteral("allRelationships");



	/**
	 * Constructor
	 * @param {String} v
	 */
	constructor(v) {
		super(v);
		this.value = v;
	}

	/**
	 * Enum value
	 * @return {String}
	 */
	value() {
		return this.value;
	}

	/**
	 * Get a CopyMode from value.
	 * @param {String} v
	 * @return {CopyMode}
	 */
	static fromValue(v) {
		for (var __i_enFor0 = 0, __exp_enFor0 = CopyMode.values(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var c = __exp_enFor0[__i_enFor0];
			if (c.value == v) {
				return c;
			}
		}
		throw new Error(v);
	}

	toString() {
		return this.value;
	}
}


// WEBPACK FOOTER //
// ./src/generated/CopyMode.js